import { freeze } from 'utils/dom'

export const TYPES = freeze({
  ROUTE: Symbol('ROUTE'),
  REDIRECT: Symbol('REDIRECT'),
  TAB: Symbol('TAB')
})

// export const LAYOUTS = freeze({
//   // SIMPLE: Symbol('SIMPLE'),
//   // SELF: Symbol('SELF'),
//   // ORG: Symbol('ORG'),
//   // SYS: Symbol('SYS')
// })
